// extracted by mini-css-extract-plugin
var _1 = "EditorNodeV2_hidden__65de9";
var _2 = "EditorNodeV2_root__2f1a7";
var _3 = "EditorNodeV2_stub__d7aa1";
var _4 = "EditorNodeV2_transparent__f55ec";
export { _1 as "hidden", _2 as "root", _3 as "stub", _4 as "transparent" }
